"use strict";

import { State } from '../../State';
import { SingleGestureName } from '../../v3/types';
import GestureHandler from './GestureHandler';
const DEFAULT_MIN_DURATION_MS = 500;
const DEFAULT_MAX_DIST_DP = 10;
const DEFAULT_NUMBER_OF_POINTERS = 1;
const SCALING_FACTOR = 10;
export default class LongPressGestureHandler extends GestureHandler {
  minDurationMs = DEFAULT_MIN_DURATION_MS;
  defaultMaxDistSq = DEFAULT_MAX_DIST_DP * SCALING_FACTOR;
  maxDistSq = this.defaultMaxDistSq;
  numberOfPointers = DEFAULT_NUMBER_OF_POINTERS;
  startX = 0;
  startY = 0;
  startTime = 0;
  previousTime = 0;
  constructor(delegate) {
    super(delegate);
    this.name = SingleGestureName.LongPress;
  }
  init(ref, propsRef, actionType, hostDetector = null) {
    if (this.enableContextMenu === undefined) {
      this.enableContextMenu = false;
    }
    super.init(ref, propsRef, actionType, hostDetector);
  }
  transformNativeEvent() {
    return {
      ...super.transformNativeEvent(),
      duration: Date.now() - this.startTime
    };
  }
  updateGestureConfig(config) {
    super.updateGestureConfig(config);
    if (config.minDurationMs !== undefined) {
      this.minDurationMs = config.minDurationMs;
    }
    if (config.maxDist !== undefined) {
      this.maxDistSq = config.maxDist * config.maxDist;
    }
    if (config.numberOfPointers !== undefined) {
      this.numberOfPointers = config.numberOfPointers;
    }
  }
  resetConfig() {
    super.resetConfig();
    this.minDurationMs = DEFAULT_MIN_DURATION_MS;
    this.maxDistSq = this.defaultMaxDistSq;
    this.numberOfPointers = DEFAULT_NUMBER_OF_POINTERS;
  }
  onStateChange(_newState, _oldState) {
    clearTimeout(this.activationTimeout);
  }
  onPointerDown(event) {
    if (!this.isButtonInConfig(event.button)) {
      return;
    }
    this.tracker.addToTracker(event);
    super.onPointerDown(event);
    this.startX = event.x;
    this.startY = event.y;
    this.tryBegin();
    this.tryActivate();
  }
  onPointerAdd(event) {
    super.onPointerAdd(event);
    this.tracker.addToTracker(event);
    if (this.tracker.trackedPointersCount > this.numberOfPointers) {
      this.fail();
      return;
    }
    const absoluteCoordsAverage = this.tracker.getAbsoluteCoordsAverage();
    this.startX = absoluteCoordsAverage.x;
    this.startY = absoluteCoordsAverage.y;
    this.tryActivate();
  }
  onPointerMove(event) {
    super.onPointerMove(event);
    this.tracker.track(event);
    this.checkDistanceFail();
  }
  onPointerOutOfBounds(event) {
    super.onPointerOutOfBounds(event);
    this.tracker.track(event);
    this.checkDistanceFail();
  }
  onPointerUp(event) {
    super.onPointerUp(event);
    this.tracker.removeFromTracker(event.pointerId);
    if (this.state === State.ACTIVE) {
      this.end();
    } else {
      this.fail();
    }
  }
  onPointerRemove(event) {
    super.onPointerRemove(event);
    this.tracker.removeFromTracker(event.pointerId);
    if (this.tracker.trackedPointersCount < this.numberOfPointers && this.state !== State.ACTIVE) {
      this.fail();
    }
  }
  tryBegin() {
    if (this.state !== State.UNDETERMINED) {
      return;
    }
    this.previousTime = Date.now();
    this.startTime = this.previousTime;
    this.begin();
  }
  tryActivate() {
    if (this.tracker.trackedPointersCount !== this.numberOfPointers) {
      return;
    }
    if (this.minDurationMs > 0) {
      this.activationTimeout = setTimeout(() => {
        this.activate();
      }, this.minDurationMs);
    } else if (this.minDurationMs === 0) {
      this.activate();
    }
  }
  checkDistanceFail() {
    const absoluteCoordsAverage = this.tracker.getAbsoluteCoordsAverage();
    const dx = absoluteCoordsAverage.x - this.startX;
    const dy = absoluteCoordsAverage.y - this.startY;
    const distSq = dx * dx + dy * dy;
    if (distSq <= this.maxDistSq) {
      return;
    }
    if (this.state === State.ACTIVE) {
      this.cancel();
    } else {
      this.fail();
    }
  }
}
//# sourceMappingURL=LongPressGestureHandler.js.map